module.exports = __webpack_public_path__ + "img/win_icon.230944bd.svg";